import { render } from "./InvoiceDetail.vue?vue&type=template&id=137893ec&ts=true"
import script from "./InvoiceDetail.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__